// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"56d58690","779":"20fb179f","787":"66609070"}[chunkId] + ".chunk.js";
};